// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-toggle-group-control.softlite-toggle-unit-options{
    min-height: 20px;
}
.components-toggle-group-control.softlite-toggle-unit-options:focus-within{
    border-color: #949494;
    box-shadow: none;
}
.softlite-toggle-unit-options .softlite-toggle-unit{
    padding: 0;
}
.softlite-toggle-unit>div{
    font-size: 8px;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/label-unit/label-unit.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;AAClB","sourcesContent":[".components-toggle-group-control.softlite-toggle-unit-options{\r\n    min-height: 20px;\r\n}\r\n.components-toggle-group-control.softlite-toggle-unit-options:focus-within{\r\n    border-color: #949494;\r\n    box-shadow: none;\r\n}\r\n.softlite-toggle-unit-options .softlite-toggle-unit{\r\n    padding: 0;\r\n}\r\n.softlite-toggle-unit>div{\r\n    font-size: 8px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
